import { KeyNodeType } from '@overtur-monorepo/keying-shared'
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { MatMenuTrigger } from '@angular/material/menu'
import { MasterKey } from '../../models/master-key'

@Component({
    selector: 'lib-key-actions',
    templateUrl: './key-actions.component.html',
    styleUrls: ['./key-actions.component.scss'],
    standalone: false
})
export class KeyActionsComponent implements OnInit {
  keyNodeType = KeyNodeType

  @Input() hierarchyItem: MasterKey
  @Input() keySystem
  @Input() isResidentialSystem = false
  @Input() budgetHierarchy = false
  @Input() selectedMasterKey: MasterKey
  @Input() isDisplay

  @Output() deleteItemAction = new EventEmitter<MasterKey>()
  @Output() deleteChildrenAction = new EventEmitter<any>()
  @Output() patchItemAction = new EventEmitter<any>()
  @Output() addChildAction = new EventEmitter<MasterKey>()

  show = false

  moveKeysEnabled = false
  renameKeysEnabled = false
  changeKeyTypeEnabled = true

  constructor() {}

  ngOnInit() {
    this.showMoveKeys()
    this.showRenameKeys()
    this.showChangeKeyType()
  }

  set(to) {
    this.show = to
  }

  addChild(data): void {
    this.addChildAction.emit(data)
  }

  patchItem(patchData) {
    this.patchItemAction.emit(patchData)
  }

  hasChangeKeys(hierarchyItem) {
    return hierarchyItem?.children?.some((c) => c.masterKeyTypeId === this.keyNodeType.ChangeKeyThruNode)
  }

  hasSubMasters(hierarchyItem) {
    return hierarchyItem?.children?.some(
      (c) => c.masterKeyTypeId === this.keyNodeType.Master || c.masterKeyTypeId === this.keyNodeType.SelectiveMaster
    )
  }

  deleteThruNotation(data) {
    this.deleteChildrenAction.emit(data)
  }

  deleteItem(hierarchyItem): void {
    this.deleteItemAction.emit(hierarchyItem)
  }

  isCrossKey(hierarchyItem: MasterKey) {
    return hierarchyItem.masterKeyTypeId === KeyNodeType.CrossKeyChild
  }

  showMoveKeys() {
    if (
      this.hierarchyItem?.keySetSymbol === this.keySystem?.topMasterKeyName ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.ControlKey ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.OrphanMaster ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.CrossKeyMaster ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.ConstructionKeyMaster
    ) {
      this.moveKeysEnabled = false
    } else if (
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.ControlKeyMaster &&
      this.hierarchyItem?.hierarchicalLevel === 'GrandMaster'
    ) {
      this.moveKeysEnabled = false
    } else {
      this.moveKeysEnabled = true
    }
  }

  showRenameKeys() {
    if (
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentMaster ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.SingleKeyDifferent ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentThruNode ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.DirectChangeMaster ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.CrossKeyMaster ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.OrphanMaster ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.ControlKeyMaster ||
      this.hierarchyItem?.masterKeyTypeId === this.keyNodeType.ConstructionKeyMaster
    ) {
      this.renameKeysEnabled = false
    } else {
      this.renameKeysEnabled = true
    }
  }

  showChangeKeyType() {
    if (this.hierarchyItem.isAssigned) {
      this.changeKeyTypeEnabled = false
    } else if (
      this.hierarchyItem.masterKeyTypeId === this.keyNodeType.ChangeKey ||
      this.hierarchyItem.masterKeyTypeId === this.keyNodeType.ControlKey ||
      this.hierarchyItem.masterKeyTypeId === this.keyNodeType.Master ||
      this.hierarchyItem.masterKeyTypeId === this.keyNodeType.SelectiveMaster ||
      this.hierarchyItem.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentMaster ||
      this.hierarchyItem.masterKeyTypeId === this.keyNodeType.SingleKeyDifferent ||
      this.hierarchyItem.masterKeyTypeId === this.keyNodeType.ConstructionKey ||
      this.hierarchyItem.masterKeyTypeId === this.keyNodeType.ChangeKeyThruNode
    ) {
      this.changeKeyTypeEnabled = true
    } else {
      this.changeKeyTypeEnabled = false
    }
  }
}
